import { MediaSlot, MediaStatus } from "@/util/enum";

export interface PhonogramModel {
	id: string;
	name: string;
	focusUnit: string;
	focusUnitId: number;
	maxReviewUnit: string;
	maxReviewUnitId: number;
	contentId: string;
	phonogramType?: string;
	phonogramTypeId: PhonogramType;
	relatedPhonogram: string;
}

export interface PhonogramDetailModel extends Omit<PhonogramModel, "contentId" | "relatedPhonogram"> {
	uploadedFiles: PhonogramDetailMedia[];
	versionGroupId: string;
	relatedPhonogramId: string;
}

export interface PhonogramDetailMedia {
	mediaSlotId: MediaSlot;
	mediaId: string;
	filePath: string;
	mediaStatusId: MediaStatus;
}

export interface PhonogramSaveModel {
	id?: string;
	name: string;
	focusUnitId: number | null;
	maxReviewUnitId?: number | null;
	phonogramTypeId: PhonogramType;
	relatedPhonogramId?: string | null;
	uploadedFiles: PhonogramSaveMedia[];
	versionGroupId?: string | null;
	hasViewingContentMedia?: boolean;
	hasAudioMedia?: boolean;
}

export interface PhonogramSaveMedia {
	id?: string;
	mediaSlotId: MediaSlot;
	mediaStatusId?: MediaStatus;
	uploadedFilePath?: string | File | null;
	audioLength?: number;
	size: number;
	isAdded: boolean;
	isRemoved: boolean;
	isModified: boolean;
}

export enum PhonogramType {
	All = 0,
	Card = 1,
	WordCard = 2
}

export enum PhonogramDeleteStatus {
	PCReferenceInPWCExistExceptionCode = 1001,
	PCRelatedItemReferenceExistExceptionCode = 1002,
	PWCRelatedItemReferenceExistExceptionCode = 1003
}
